export default "__VITE_ASSET__CDL$U6K0__"